import type { Location } from 'react-router-dom';

type Args = {
  /** 現在のパス。 */
  location: Location;
  /** クエリパラメータ。 */
  params: URLSearchParams;
};

/** クエリパラメータを更新する関数。 */
export const updateQueryParams = ({ location, params }: Args) => {
  window.history.replaceState(
    {},
    '',
    `${location.pathname}?${params.toString()}`
  );
};
